<template>
  <div>
    <div class="mt-16 ml-16" @mouseenter="stopScroll" @mouseleave="startScroll">
      <table
        class="table"
        cellspacing="0"
        cellpadding="0"
        style="border: 1px solid #007a4d"
        :class="{ 'animated-top': animatedTop && this.sonData.length > 3 }"
      >
        <tr
          style="font-size: 16px"
          class="tr-line"
          v-for="(item, index) in importantList"
          :key="'importantList_' + index"
          :class="{
            'has-bg': index % 2 == 1,
          }"
        >
          <td class="td-1">
            <div>{{ item.stuNum }}</div>
          </td>
          <td class="td-1">
            <div>{{ item.stuName }}</div>
          </td>
          <td class="td-1">
            <div>{{ item.teamName }}</div>
          </td>
          <td class="td-1">
            <div>缺训（{{ item.num }}）</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['importantList'],
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      barOption: {},
      sonData: [],
      animatedTop: false,
    }
  },
  watch: {
    importantList: {
      handler: function () {
        this.sonData = this.importantList
      },
      deep: true,
    },
  },
  created() {
    this.sonData = this.importantList
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.sonData.length > 4) {
        this.animatedTop = true
        setTimeout(() => {
          this.sonData.push(this.sonData[0])
          this.sonData.shift()
          this.animatedTop = false
          console.log('this.sonData,', this.sonData[0])
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  methods: {
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.timer = setInterval(() => {
        if (this.sonData.length > 4) {
          this.animatedTop = true
          setTimeout(() => {
            this.sonData.push(this.sonData[0])
            this.sonData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style lang="scss" scoped>
.t-head {
  width: 512px;
  height: 34px;
  background: linear-gradient(
    0deg,
    rgba(6, 88, 58, 0.0884779) -24.83%,
    #06583a 100%
  );
}
// td {
//   padding: 0px 16px;
// }

.td-1 {
  width: 127px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  div {
    width: 127px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
  }
}
.tr-line {
  font-size: 14px;
  width: 512px;
  height: 34px;
  cursor: pointer;
}

.has-bg {
  //   background: rgba(0, 122, 77, 0.1);
  background: rgba(255, 255, 255, 0.05);
}
.mt-16 {
  margin-top: 16px;
}
.ml-8 {
  margin-left: 8px;
}
// .ml-16 {
//   margin-left: 16px;
// }
table,
table tr {
  border: 1px solid #007a4d;
}
table {
  border-collapse: collapse;
}

.animated-top {
  transition: all 0.5s;
  //   margin-top: -37px;
}
</style>
